import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/compact/g6-instant.png";
import { type Product } from "../../types";
import { physicalSecurityCompact } from "../product-list-groups/physicalSecurityCompact";
import { deployment, outdoorReady } from "../properties";

export const g6Instant: Product = {
  id: "g6Instant",
  productTitle: "G6 Instant",
  description: "g6Instant.description",
  descriptionMaxWidth: 184,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g6-ins`,
  ],
  storePathParts: {
    productSlug: "uvc-g6-ins",
    category: UniFiChildCategorySlug.CamerasCompact,
  },
  image: { src: image, width: 200, height: 140 },
  isNew: true,
  productListGroup: physicalSecurityCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '81.7 x 50.1 x 57.2 mm\n(3.2 x 2 x 2.3")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: "1/1.8” 8MP" },
    },
    {
      propertyId: "fieldOfView",
      value: { type: "translation", value: "g6Instant.fieldOfView" },
    },
    {
      propertyId: "nightVision",
      // TODO: Check if need translation
      value: { type: "string", value: "6 m (20 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "translation", value: "g6Instant.outdoorReady" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "translation", value: "g6Instant.deployment" },
    },
  ],
};
